
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/privacy",
      function () {
        return require("private-next-pages/about/privacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/privacy"])
      });
    }
  